var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-page container" },
    [
      _c("block-breadcrumbs", { attrs: { items: _vm.breadcrumbs } }),
      _c("product-card"),
      _c("product-info", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.adaptive.isMobile,
            expression: "!adaptive.isMobile"
          }
        ],
        staticClass: "product-page__info",
        attrs: {
          "product-code": _vm.PRODUCT.code,
          "city-name": _vm.CITY.name,
          "active-sku": _vm.ACTIVE_SKU
        }
      }),
      _c("product-gallery-recomendations", {
        staticClass: "product-page__recomendations",
        attrs: { "product-ids": [_vm.PRODUCT.id] }
      }),
      _c("product-gallery-recently-viewed")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }